import React, { useContext } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { Measurement } from "../classes/measurements/measurement";
import { TextBlock } from "../common/components/generalUtilities";
import { GoalsTablePropsShape } from "../interfaces/componentTypes";

export const GoalsTable: React.FunctionComponent<GoalsTablePropsShape> = ({
  templateSet,
}) => {
  const {
    DBObject,
    t,
    api,
    router,
    setNavPage,
    uuid,
    setTemplateSet,
  } = useContext(TMDataContext);

  const formatColumnHeadings = () => {
    return DBObject.indexTableHeaders.map((header) => {
      return (
        <th
          key={uuid()}
          className="goal-table-heading-cell"
          style={{ width: `${header.id == 8 ? "80px" : "auto"}` }}
        >
          <span>{t(`views.goals.table.headings.${header.name}`)}</span>
        </th>
      );
    });
  };

  const editData = (data) => {
    let preparedRoute = router.goToForm(data.type.name, "edit", data);
    setNavPage(preparedRoute);
  };

  const deleteData = (data) => {
    if (confirm(t("views.goals.navigation.delete_prompt"))) {
      setTemplateSet("delete", data);
    }
  };

  const setCRUDIcons = (data) => {
    return (
      <div className="edit-icon-wrap">
        <i className="icon-edit edit-icon" onClick={() => editData(data)}></i>
        <i
          className="icon-delete delete-icon"
          onClick={() => deleteData(data)}
        ></i>
      </div>
    );
  };

  const buildGoalTable = (templateSet) => {
    if (templateSet === undefined || templateSet.length == 0)
      return <TextBlock block={t("views.goals.headings.empty_index")} />;

    return templateSet.map((template) => {
      return (
        <tr
          className="goal-table-data-row"
          key={uuid()}
          style={{
            backgroundColor: `${template.hasErrors ? "#CC444A19" : ""}`,
            border: `${template.hasErrors ? "3px solid #cc444a" : ""}`,
          }}
        >
          <td className="goal-table-data-cell">{template.name}</td>
          <td className="goal-table-data-cell">{template.type.label}</td>
          <td className="goal-table-data-cell">
            {template.measurementId
              ? Measurement.findById(template.measurementId).labelWithUnits()
              : "--"}
          </td>
          <td className="goal-table-data-cell">{template.achievementTarget}</td>
          <td className="goal-table-data-cell">
            {template.type.name == "GoalTemplateObservation"
              ? template.achievementThreshold +
                t("models.measurement_unit.label.%")
              : template.achievementThreshold}
          </td>
          <td className="goal-table-data-cell">
            {template.user.lastName}, {template.user.firstName}
          </td>
          <td className="goal-table-data-cell">
            {template.occurrenceFrequency.label}
          </td>
          <td
            className="goal-table-data-cell"
            style={{
              fontStyle:
                template.createdAtFormatted ==
                t("views.goals.navigation.save_for_created_at_date")
                  ? "italic"
                  : "normal",
            }}
          >
            {template.createdAtFormatted}
          </td>
          <td className="goal-table-data-cell">{setCRUDIcons(template)}</td>
        </tr>
      );
    });
  };

  return (
    <div>
      <table className="goal-table-wrapper">
        <thead>
          <tr className="goal-table-heading-row">{formatColumnHeadings()}</tr>
        </thead>
        <tbody>{templateSet ? buildGoalTable(templateSet) : null}</tbody>
      </table>
    </div>
  );
};
